import { Button, Col, Input, Modal, Row, Typography } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { useStudentSearch } from "hooks/useStudentSearch";
import React, { useCallback, useMemo, useState } from "react";

const { Title, Paragraph } = Typography;

interface Props {
  eventId: number;
  alreadyRegisteredStudentIds: number[];
  onRegistration: (studentId: number) => void;
}

const ManualRegistration: React.FC<Props> = ({ eventId, alreadyRegisteredStudentIds, onRegistration }) => {
  const [loadingModal, setLoadingModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { students, handleStudentSearch, loadingStudents } = useStudentSearch();

  const handleRegister = useCallback(
    (studentId: number, studentName: string) => {
      Modal.confirm({
        title: `Meld på arrangementet`,
        content: `Er du sikker på at du vil melde ${studentName} på arrangementet?`,
        onOk: () => {
          setLoadingModal(true);
          return axios
            .post(`/events/${eventId}/admin_register/`, {
              student: studentId,
            })
            .then(() => {
              message("success", `Studenten er meldt på arrangementet`);
              onRegistration(studentId);
              setSearchValue("");
              handleStudentSearch("");
            })
            .catch(() => {
              message("error", "En feil oppstod", "Studenten ble ikke meldt på arrangementet");
            })
            .finally(() => {
              setLoadingModal(false);
            });
        },
        okButtonProps: {
          type: "primary",
        },
        okText: "Meld på",
        cancelText: "Avbryt",
      });
    },
    [eventId, onRegistration, handleStudentSearch]
  );
  const studentsNotYetRegistered = useMemo(() => {
    return students?.filter(student => !alreadyRegisteredStudentIds.includes(student.id));
  }, [students, alreadyRegisteredStudentIds]);
  return (
    <Col>
      <Row>
        <Title level={5} style={{ fontWeight: "normal", fontSize: "0.9rem" }}>
          Meld på studenter manuelt
        </Title>
      </Row>
      <Row>
        <Input
          placeholder="Søk etter studenter"
          value={searchValue}
          onChange={e => {
            setSearchValue(e.target.value);
            handleStudentSearch(e.target.value);
          }}
        />
      </Row>
      <Row>
        {loadingStudents && <Paragraph>Laster inn studenter...</Paragraph>}
        {studentsNotYetRegistered?.length === 0 && !loadingStudents && <Paragraph>Ingen studenter funnet</Paragraph>}
        {studentsNotYetRegistered && studentsNotYetRegistered.length > 0 && (
          <Col span={24}>
            {studentsNotYetRegistered.map(student => (
              <Row key={student.id} style={{ paddingTop: "6px" }}>
                <Col span={12}>
                  {student.first_name} {student.last_name}
                </Col>
                <Col span={6}>{student.username}</Col>
                <Col span={6} style={{ textAlign: "end" }}>
                  <Button
                    onClick={() => handleRegister(student.id, `${student.first_name} ${student.last_name}`)}
                    loading={loadingModal}
                    disabled={loadingModal}
                  >
                    Meld på
                  </Button>
                </Col>
              </Row>
            ))}
          </Col>
        )}
      </Row>
    </Col>
  );
};

export default ManualRegistration;
